"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PriceMatrixColumn = _interopRequireDefault(require("./components/PriceMatrixColumn"));
var _PriceMatrixDaysCount = _interopRequireDefault(require("./components/PriceMatrixDaysCount"));
var _PriceMatrixTitle = _interopRequireDefault(require("./components/PriceMatrixTitle"));
var _utils = require("./utils");
var PriceMatrix = function PriceMatrix(props) {
  var target = props.target,
    data = props.data,
    isMobile = props.isMobile,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$columnCount = props.columnCount,
    columnCount = _props$columnCount === void 0 ? 5 : _props$columnCount;
  var datesList = Object.entries(data);
  var list = (0, _utils.splitChosingMiddle)(datesList, columnCount, target.start_date);
  var durationsCount = Object.keys(list[0][1]).map(function (key) {
    return Number(key);
  });
  var daysCount = list.map(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 1),
      date = _ref2[0];
    return date;
  });
  return /*#__PURE__*/_react["default"].createElement(StyledPriceMatrix, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_PriceMatrixTitle["default"], {
    target: target,
    daysCount: daysCount,
    isMobile: isMobile
  }), /*#__PURE__*/_react["default"].createElement(PriceMatrixTableBody, null, !isMobile && /*#__PURE__*/_react["default"].createElement(_PriceMatrixDaysCount["default"], {
    target: target,
    durationsCount: durationsCount
  }), list.map(function (_ref3) {
    var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
      date = _ref4[0],
      durationsObj = _ref4[1];
    return /*#__PURE__*/_react["default"].createElement(_PriceMatrixColumn["default"], {
      key: date,
      durationsObj: durationsObj,
      isMobile: isMobile,
      isTargetColumn: date === target.start_date,
      target: target
    });
  }))));
};
var StyledPriceMatrix = _styledComponents["default"].div.withConfig({
  displayName: "PriceMatrix__StyledPriceMatrix",
  componentId: "sc-gggdgu-0"
})(["display:flex;"]);
var PriceMatrixTableBody = _styledComponents["default"].div.withConfig({
  displayName: "PriceMatrix__PriceMatrixTableBody",
  componentId: "sc-gggdgu-1"
})(["display:flex;"]);
var _default = exports["default"] = PriceMatrix;